import { createSelector } from "reselect";
import { populationSectionSelector } from "../population_section_selector";

export const acquiredFilterSelector = createSelector(
  populationSectionSelector,
  populationSection => {
    return populationSection.acquiredFilter;
  }
);
